module.exports = __webpack_public_path__ + "files/SPIADI2021 - Présentation SRLF.104d56963bbfcea2dad3b8448bf0ef56.pdf";